(() => {
  const root = document.documentElement;
  root.classList.add('cd-xmas-mode');
  const assets = window.cdXmasThemeAssets || {};
  const decorateCategoryRings = () => {
    const rings = Array.isArray(assets.categoryRibbonRings) ? assets.categoryRibbonRings.filter(Boolean) : [];
    if (!rings.length) return;
    const section = document.querySelector('#template--23296030540001__collection_list_NGWdyd');
    const items = section ? Array.from(section.querySelectorAll('.bls__collection-image')) : [];
    let pool = [];
    const refill = () => {
      pool = rings.map((_, index) => index);
      for (let index = pool.length - 1; index > 0; index -= 1) {
        const swap = Math.floor(Math.random() * (index + 1));
        [pool[index], pool[swap]] = [pool[swap], pool[index]];
      }
    };
    items.forEach((item) => {
      if (item.dataset.cdRibbonRing) return;
      if (!pool.length) refill();
      const ringIndex = pool.pop();
      item.dataset.cdRibbonRing = String(ringIndex + 1);
      item.style.setProperty('--cd-xmas-category-ribbon-ring', 'url("' + rings[ringIndex] + '")');
    });
  };
  decorateCategoryRings();
  window.setTimeout(decorateCategoryRings, 700);
  const decorateCategorySlider = () => {
    if (window.matchMedia('(max-width: 749px)').matches) return;
    const section = document.querySelector('#template--23296030540001__collection_list_NGWdyd');
    const swiper = section && section.querySelector('.swiper');
    const parent = swiper && swiper.parentElement;
    if (!parent || parent.querySelector('.cd-xmas-category-slide-hint')) return;
    const hint = document.createElement('div');
    hint.className = 'cd-xmas-category-slide-hint';
    hint.setAttribute('aria-hidden', 'true');
    hint.innerHTML = '<span>Desliza para ver más</span><b><i>›</i><i>›</i></b>';
    parent.insertBefore(hint, swiper);
  };
  decorateCategorySlider();
  window.setTimeout(decorateCategorySlider, 700);
  const replaceMedia = (element, url) => {
    if (!element || !url) return;
    if (element.tagName === 'IMG') {
      element.src = url;
      element.srcset = url;
      element.removeAttribute('data-src');
      element.removeAttribute('data-srcset');
      element.classList.add('cd-xmas-promo-img');
    } else {
      element.style.setProperty('background-image', 'url("' + url + '")', 'important');
      element.removeAttribute('data-img-slide');
      element.removeAttribute('data-img-slide-mobile');
    }
  };
  const applyHeroSlides = () => {
    const slides = Array.from(document.querySelectorAll('.bls__slideshow .bls__slide-items'));
    slides.forEach((slide, fallbackIndex) => {
      const rawIndex = slide.getAttribute('data-swiper-slide-index');
      const slideIndex = rawIndex === null ? fallbackIndex % 3 : Number(rawIndex) % 3;
      const desktopUrl = Array.isArray(assets.heroDesktop) ? assets.heroDesktop[slideIndex] : assets.heroDesktop;
      const mobileUrl = Array.isArray(assets.heroMobile) ? assets.heroMobile[slideIndex] : assets.heroMobile;
      slide.querySelectorAll('.desktop .slide-bg-image').forEach((element) => {
        replaceMedia(element, desktopUrl);
        element.querySelectorAll('img').forEach((image) => { image.style.opacity = '0'; });
      });
      slide.querySelectorAll('.mobile .slide-bg-image').forEach((element) => {
        replaceMedia(element, mobileUrl);
        element.querySelectorAll('img').forEach((image) => { image.style.opacity = '0'; });
      });
      if (slideIndex === 0) {
        const frame = slide.querySelector('.slide-items') || slide;
        const mainLink = frame.querySelector('.sf-slider__link');
        const button = frame.querySelector('.slide__block-link');
        const subheading = frame.querySelector('.slide__block-subtitle');
        const heading = frame.querySelector('.slide__block-title');
        const description = frame.querySelector('.slide__block-des');
        if (mainLink) mainLink.href = '/collections/nuevos-llegadas';
        if (button) { button.href = '/collections/nuevos-llegadas'; button.textContent = 'Ver novedades'; }
        if (subheading) subheading.textContent = 'Nuevas llegadas';
        if (heading) heading.textContent = 'Descubre lo nuevo en China Depot';
        if (description) description.innerHTML = '<p>Productos prácticos, regalos y novedades seleccionadas para esta temporada.</p>';
      }
      if (slideIndex === 1) {
        const frame = slide.querySelector('.slide-items') || slide;
        if (!frame.querySelector('.cd-xmas-slide-copy--2')) {
          const copy = document.createElement('a');
          copy.className = 'cd-xmas-slide-copy--2';
          copy.href = '/collections/navidad';
          copy.innerHTML = '<small>Decoración que ilumina</small><strong>Navidad que brilla</strong><span>Árboles, luces y figuras para transformar cada espacio.</span><b>Ver Navidad</b>';
          frame.appendChild(copy);
        }
        const mainLink = frame.querySelector('.sf-slider__link');
        if (mainLink) mainLink.href = '/collections/navidad';
      }
      if (slideIndex === 2) {
        const frame = slide.querySelector('.slide-items') || slide;
        frame.querySelectorAll('.bls__slide-content').forEach((element) => { element.style.display = 'none'; });
        if (!frame.querySelector('.cd-xmas-slide-copy--3')) {
          const copy = document.createElement('a');
          copy.className = 'cd-xmas-slide-copy--3';
          copy.href = '/collections/los-mas-vendidos';
          copy.innerHTML = '<small>Promoción de temporada</small><strong>Favoritos para regalar</strong><span>Descubre nuestros productos más buscados y encuentra el regalo ideal esta Navidad.</span><b>Ver más vendidos</b>';
          frame.appendChild(copy);
        }
        const mainLink = frame.querySelector('.sf-slider__link');
        if (mainLink) mainLink.href = '/collections/los-mas-vendidos';
        frame.querySelectorAll('a[href*="/collections/all"]').forEach((link) => { link.href = '/collections/los-mas-vendidos'; });
      }
    });
  };
  applyHeroSlides();
  window.setTimeout(applyHeroSlides, 350);
  window.setTimeout(applyHeroSlides, 1200);
  const promoGroups = [
    { tokens: ['/39.png', '/40.png'], eyebrow: 'Regalos para todos', title: 'Navidad llena de sorpresas', copy: 'Encuentra detalles especiales para el hogar, la familia y el negocio.' },
    { tokens: ['/41_', '/42_'], eyebrow: 'Celebra en grande', title: 'Todo para esta Navidad', copy: 'Decoración, luces, regalos y precios que hacen brillar la temporada.' }
  ];
  promoGroups.forEach((group) => {
    const image = Array.from(document.images).find((candidate) => group.tokens.some((token) => (candidate.currentSrc || candidate.src || '').includes(token)));
    if (!image) return;
    const section = image.closest('section');
    if (!section || section.classList.contains('cd-xmas-promo-section')) return;
    section.classList.add('cd-xmas-promo-section');
    section.querySelectorAll('img').forEach((candidate) => replaceMedia(candidate, assets.promoBanner));
    const overlay = document.createElement('a');
    overlay.className = 'cd-xmas-promo-copy';
    overlay.href = '/collections/navidad';
    overlay.innerHTML = '<small>' + group.eyebrow + '</small><strong>' + group.title + '</strong><span>' + group.copy + '</span><b>Comprar Navidad</b>';
    section.appendChild(overlay);
  });
  // Collection banners are now server-rendered by cd-category-hero.
  const snow = document.querySelector('[data-cd-snow]');
  if (!snow || snow.childElementCount) return;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;
  const glyphs = ['❄','✦','•'];
  const fragment = document.createDocumentFragment();
  for (let i = 0; i < 38; i += 1) {
    const flake = document.createElement('i');
    flake.textContent = glyphs[i % glyphs.length];
    flake.style.setProperty('--x', String((i * 37 + 11) % 100));
    flake.style.setProperty('--s', String(9 + (i * 7) % 13));
    flake.style.setProperty('--o', String(.35 + ((i * 13) % 55) / 100));
    flake.style.setProperty('--d', String(9 + (i * 11) % 12));
    flake.style.setProperty('--delay', String((i * 17) % 19));
    flake.style.setProperty('--drift', String(-55 + (i * 23) % 110));
    fragment.appendChild(flake);
  }
  snow.appendChild(fragment);
})();